import React, { useEffect, useState, useContext } from 'react';
import { fetchProfileData } from './api.js';
import { useHookState } from './NotificationApiHook';
import { Typography, Skeleton, Container, Paper, Box } from '@mui/material';
import { PlaceContext } from '../contexts/PlaceContext';
import { AuthContext } from './AuthContext';

function Profile() {
  const [profileData, setProfileData] = useState(null);
  const { notificationState } = useHookState();
  const [loggedIn, setLoggedIn] = useState(false);
  const { isLoggedIn } = useContext(AuthContext);
  const { placeId } = useContext(PlaceContext);

  useEffect(() => {
    setLoggedIn(isLoggedIn);
    const token = localStorage.getItem('token');
    if (token) {
      fetchProfileData(token, notificationState, 0, placeId)
        .then((data) => {
          setProfileData(data);
        })
        .catch((error) => {
          console.error('Ошибка при получении профиля:', error);
        });
    } else {
      setProfileData(null); // Обнуляем данные профиля, если токен отсутствует
    }
  }, [isLoggedIn]);

  if (!profileData && loggedIn) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  if (!loggedIn) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Typography
          variant='h6'
          sx={{ textAlign: 'center', marginBottom: '50px' }}
        >
          Профиль недоступен <br /> Войдите в систему
        </Typography>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  return (
    <Box sx={{ mt: 10 }}>
      <Paper
        elevation={3}
        sx={{ p: 4, mt: 10, maxWidth: 400, margin: 'auto' }}
      >
        <Typography
          variant='h4'
          gutterBottom
        >
          Профиль
        </Typography>
        <Typography
          variant='h6'
          sx={{ mt: 2 }}
        >
          Привет, {profileData.name}!
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 2 }}
        >
          Ваш баланс: {profileData.balance} ₽
        </Typography>
      </Paper>
    </Box>
  );
}

export default Profile;
